import { authStore } from '../stores';
import { getUserEmail } from '@sweatpals/shared';
import { isClient } from '../constants';
import { sweatPalsFBPixelID } from '../constants/fb-pixel';

const pixelOptions = {
	autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
	debug: true, // enable logs
};

export async function initFBPixel (pixelIds: string[]) {
	if (!isClient) return;

	const advancedMatching = authStore.user
		? { external_id: authStore.user.id, em: getUserEmail(authStore.user), fn: authStore.user.fullName }
		: undefined;

	for (const pixelId of pixelIds) {
		if (!pixelId) continue;

		// (window as any).fbq?.('set', 'autoConfig', pixelOptions.autoConfig, pixelId);
		(window as any).fbq?.('init', pixelId, advancedMatching);

		if (pixelOptions.debug) {
			console.debug('fbq.init', pixelId, advancedMatching);
		}
	}
}

export function track (eventName: string, options?: object | void) {
	if (pixelOptions.debug) {
		console.debug('fbq.track', eventName, options ?? {});
	}

	(window as any).fbq?.('track', eventName, options ?? {});
}

export function trackSingle (pixelId: string, eventName: string, options = {}) {
	if (pixelOptions.debug) {
		console.debug('fbq.trackSingle', pixelId, eventName, options);
	}

	if (!pixelId) {
		return;
	}

	(window as any).fbq?.('trackSingle', pixelId, eventName, options);
}

export function pageview () {
	track('PageView');
}

export function pageviewSingle (pixelId: string) {
	trackSingle(pixelId, 'PageView');
};

// sweatpals specific

export const initSweatPalsFBPixel = () => {
	if (!sweatPalsFBPixelID) return;

	initFBPixel([sweatPalsFBPixelID]);
};

export const trackSweatPals = (eventName: string, options = {}) => {
	trackSingle(sweatPalsFBPixelID as string, eventName, options);
};
